import throttle from '@/throttle'

document.addEventListener('DOMContentLoaded', () => {
  const DOMScope = document.querySelector(
    '[data-scope-path="layouts/_bottom_fixed_banner"]'
  )
  const bannerContainer = DOMScope.querySelector('.js-container')
  const toTopButton = document.querySelector(
    '[data-scope-path="layouts/_scroll_to_top"] .js-scroll-to-top-button'
  ) as HTMLElement
  const footer = document.querySelector(
    '[data-scope-path="layouts/_footer"]'
  ) as HTMLElement
  const isMobile = document.body.clientWidth < 768

  // トップに戻るボタンの位置をいい感じにずらす
  toTopButton.style.bottom = '130px'

  // バツボタンを押したら DOMScope ごと削除
  bannerContainer
    .querySelector('.js-close-button')
    .addEventListener('click', () => {
      DOMScope.parentElement.removeChild(DOMScope)
      if (isMobile) {
        footer.style.marginBottom = 'inherit'
      }
      toTopButton.style.bottom = '30px'
    })

  // SNS シェアボタンがある場合はスマホサイズで非表示にする用のクラスを付与
  {
    const SNSShare = document.querySelector(
      '[data-scope-path="partials/article/_sns_share"]'
    )
    if (SNSShare) {
      DOMScope.classList.add('js-mobile-hidden')
    } else if (isMobile) {
      // バナーがページ一番下まで行ってもフッターの要素とかぶらないよう余白を用意する
      footer.style.marginBottom = '70px'
    }
  }

  // Viewport の高さ半分スクロールしたら、要素を見えなくするためのクラスを削除
  // Viewport の高さ半分スクロールできない高さの場合、要素を吹き飛ばすためのクラスを付与
  {
    let threshold: number
    const setThreshold = throttle(() => {
      threshold = window.innerHeight / 2
    }, 17) // ≒ 60fps
    setThreshold()

    const controlClassInvisible = throttle(() => {
      threshold < (window.scrollY || window.pageYOffset)
        ? bannerContainer.classList.remove('js-invisible')
        : bannerContainer.classList.add('js-invisible')
    }, 17) // ≒ 60fps
    controlClassInvisible()

    const controlClassHidden = throttle(() => {
      document.body.clientHeight < threshold * 2
        ? bannerContainer.classList.add('js-hidden')
        : bannerContainer.classList.remove('js-hidden')
    }, 17) // ≒ 60fps
    controlClassHidden()

    window.addEventListener('scroll', controlClassInvisible)
    window.addEventListener('resize', setThreshold)
    window.addEventListener('resize', controlClassHidden)
    window.addEventListener('resize', controlClassInvisible)
  }

  // 親要素が全て見えたら container 位置を親要素からの absolute にするクラスを付与
  {
    const controlClass = (entries: IntersectionObserverEntry[]) => {
      entries[0].intersectionRatio >= 1
        ? bannerContainer.classList.add('js-desktop-stick-parent')
        : bannerContainer.classList.remove('js-desktop-stick-parent')
    }
    const observer = new IntersectionObserver(controlClass, { threshold: 1 })

    observer.observe(DOMScope)
  }
})
